import { useAuthenticatedRoutes } from "hooks/useAuthenticatedRoutes"
import React from "react"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import { VesaRouteType } from "routes"

type OutletRedirectChildPrps = {
  basePath?: string
  children?: VesaRouteType[]
}
const OutletRedirectChild = ({
  basePath,
  children,
}: OutletRedirectChildPrps) => {
  const location = useLocation()
  const validChildren = useAuthenticatedRoutes({
    routes: children,
    showHidden: false,
    scanDeep: false,
  })
  if (location.pathname === basePath && validChildren.length) {
    return <Navigate to={validChildren[0].path} />
  }
  return <Outlet />
}

export default OutletRedirectChild
